import { NordEvent } from '../common/events.js'

/**
 * Dispatched after the value update applies when every OTP cell becomes filled
 * (`value.length === length`), or when a complete value is pasted while the
 * field is already complete. Carries the completed value so consumers can react
 * to completion (for example, submitting the owning form).
 *
 * Fired after `input`/`change` so the committed value is already readable on the
 * host, mirroring Base UI's `onValueComplete`-after-`onValueChange` ordering.
 */
export class OtpFieldCompleteEvent extends NordEvent {
  static eventName = 'complete'

  constructor(
    /** The completed OTP value, e.g. `'123456'`. */
    public readonly value: string,
  ) {
    super(OtpFieldCompleteEvent.eventName)
  }

  /** Convenience accessor mirroring `CustomEvent.detail`. */
  get detail() {
    return this.value
  }
}

/**
 * Dispatched when typed or pasted text contained characters rejected by the
 * field's `type` normalization (for example, letters typed into a `numeric`
 * field). Carries the raw attempted string before normalization.
 *
 * Named `value-invalid` rather than `invalid` so it does not collide with the
 * native `HTMLInputElement` `invalid` event.
 */
export class OtpFieldInvalidEvent extends NordEvent {
  static eventName = 'value-invalid'

  constructor(
    /** The raw text the user attempted to enter, before normalization. */
    public readonly value: string,
  ) {
    super(OtpFieldInvalidEvent.eventName)
  }

  /** Convenience accessor mirroring `CustomEvent.detail`. */
  get detail() {
    return this.value
  }
}
